import React, { useState } from 'react'

import useSWR from '../../../hooks/useSWR'

const TransportManagers = () => {
  const [search, setSearch] = useState('')
  const [transportManager, setTransportManager] = useState(null)

  const { data: list } = useSWR(search.length > 3 && '/subject/admin/transport_managers', { search })

  const handleClick = (t) => {
    setTransportManager(t)
    setSearch('')
  }

  return (
    <div>
      <br />
      <input
        type="text"
        placeholder="Email"
        value={search}
        onChange={(e) => {
          if (transportManager) setTransportManager(null)
          setSearch(e.target.value)
        }}
      />
      <br />
      <div className="flex" style={{ justifyContent: 'start', marginTop: '5px' }}>
        {list?.map((t) => (
          <div key={t.email} style={{ background: '#fff', cursor: 'pointer', marginRight: '5px', padding: '2px' }} onClick={() => handleClick(t)}>
            {t.email}
          </div>
        ))}
      </div>

      <br />

      {transportManager && (
        <div>
          <h4>Transportansvarig:</h4>
          {transportManager.email}
          <br />
          <br />
          <h4>Aktiva projekt:</h4>
          {transportManager.locks.map((lock) => {
            if (lock.active !== false) {
              return <div key={lock.customName}>{lock.customName}</div>
            }
            return null
          })}
          <br />
          <h4>Inaktiva projekt:</h4>
          {transportManager.locks.map((lock) => {
            if (lock.active === false) {
              return <div key={lock.customName}>{lock.customName}</div>
            }
            return null
          })}
        </div>
      )}
    </div>
  )
}

export default TransportManagers
